import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { ReplaySubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private _mapReadySubject = new ReplaySubject<typeof google>(1);
  public mapReady$: Observable<typeof google> = this._mapReadySubject.asObservable();

  constructor() {
    const loader = new Loader({
      apiKey: environment.googleMapsApiKey,
      libraries: ['places']
    });

    loader.load().then((google) => {
      this._mapReadySubject.next(google);
      this._mapReadySubject.complete();
    }).catch(error => {
      console.error('Error loading Google Maps API:', error);
    });
  }
}
